// extracted by mini-css-extract-plugin
export default {"imageContainer":"ydkW4","defaultImage":"_215Nu","defaultImageMobile":"_3jfO5"};